import { render, staticRenderFns } from "./consultationCard.vue?vue&type=template&id=5ec45f0b&scoped=true&"
import script from "./consultationCard.vue?vue&type=script&lang=js&"
export * from "./consultationCard.vue?vue&type=script&lang=js&"
import style0 from "./consultationCard.vue?vue&type=style&index=0&id=5ec45f0b&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "5ec45f0b",
  null
  
)

export default component.exports